import { Check } from "lucide-react";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const ChipGroup = ({ label, options, value, onChange, multi, testid }) => {
  const isOn = (o) => (multi ? value.includes(o) : value === o);
  const toggle = (o) => (multi ? onChange(isOn(o) ? value.filter((v) => v !== o) : [...value, o]) : onChange(o));
  return (
    <div data-testid={testid}>
      <p className="text-[13px] font-medium text-slate-700">
        {label} <span className="text-[#C20500]">*</span>
        {multi && <span className="ml-1 text-xs font-normal text-slate-400">(pick all that apply)</span>}
      </p>
      <div className="mt-2 flex flex-wrap gap-2">
        {options.map((o) => (
          <button
            key={o}
            type="button"
            onClick={() => toggle(o)}
            data-testid={`${testid}-${slug(o)}`}
            aria-pressed={isOn(o)}
            className={`inline-flex items-center gap-1.5 rounded-full border px-3.5 py-2 text-sm transition-colors ${
              isOn(o) ? "border-[#123634] bg-[#123634] text-white" : "border-slate-300 bg-white text-slate-700 hover:border-[#123634]"
            }`}
          >
            {isOn(o) && <Check className="h-3.5 w-3.5" />} {o}
          </button>
        ))}
      </div>
    </div>
  );
};
